import React from 'react';

const CenterPoint = () => {
	return (
		<svg
			width="93"
			height="93"
			viewBox="0 0 93 93"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clip-path="url(#clip0_5_285)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M53.6716 82.457C52.5757 82.4234 51.6886 81.5619 51.6215 80.4655C51.5581 79.3728 52.3446 78.4106 53.4293 78.254C72.0666 75.3003 86.1787 59.9538 86.1787 41.497C86.1787 36.8875 85.3102 32.4943 83.7037 28.4329H83.7074C83.4912 27.9071 83.4912 27.3216 83.7149 26.8032C83.9385 26.2773 84.3597 25.8708 84.8816 25.662C85.4109 25.4569 85.9961 25.4681 86.5142 25.6956C87.0286 25.9268 87.4349 26.3519 87.6324 26.8852C89.4253 31.4314 90.3982 36.3579 90.3982 41.5045C90.3982 62.1169 74.6348 79.1789 54.0853 82.4346H54.0891C53.9474 82.457 53.8095 82.4682 53.6679 82.4645L53.6716 82.457Z"
					fill="white"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M79.2271 19.0311C78.6046 19.0237 78.0194 18.7365 77.6243 18.2554C70.4489 9.72254 59.3784 4.22168 46.9287 4.22168C34.479 4.22168 23.4383 9.71508 16.2666 18.233C15.9088 18.6731 15.3907 18.9528 14.8278 19.0013C14.2687 19.0535 13.7059 18.8782 13.2735 18.5127C12.8411 18.1473 12.5727 17.6251 12.528 17.062C12.487 16.5026 12.6696 15.9394 13.0387 15.5143C21.0117 6.04162 33.2564 0 46.9287 0C60.601 0 72.8792 6.05281 80.8523 15.5367H80.856C81.4002 16.1669 81.5232 17.0583 81.1728 17.8153C80.8187 18.5687 80.0546 19.0498 79.2271 19.0311Z"
					fill="white"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M40.5062 82.5092C40.3869 82.5092 40.2677 82.5017 40.1521 82.4793C19.4163 79.369 3.46277 62.2287 3.46277 41.4932C3.46277 36.4772 4.39091 31.6663 6.10181 27.2134C6.29936 26.6838 6.6982 26.2549 7.21632 26.0237C7.72698 25.7887 8.31219 25.7738 8.84149 25.9752C9.37078 26.1766 9.79571 26.5868 10.0156 27.1015C10.243 27.6161 10.2542 28.2091 10.0455 28.7312C8.5172 32.7142 7.68598 36.9956 7.68598 41.497C7.68598 60.0619 21.9659 75.4792 40.7783 78.3024C41.8742 78.4516 42.6719 79.4212 42.601 80.5288C42.5302 81.6365 41.617 82.498 40.5062 82.5054V82.5092Z"
					fill="white"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M23.9862 43.4513C22.991 43.3842 22.1113 42.5227 22.0218 41.527C21.9361 40.5312 22.6518 39.5317 23.6209 39.2893L33.4875 36.8466L1.15555 19.5832C0.145408 19.0834 -0.305614 17.6924 0.223685 16.7004C0.752983 15.7046 2.15823 15.2981 3.13483 15.8538L36.0296 33.4155L33.3906 23.6445C32.9955 22.5518 33.6962 21.198 34.8145 20.8885C35.9327 20.5789 37.2261 21.3845 37.4498 22.522L41.2779 36.7496C41.6954 38.081 41.0542 39.3341 39.8577 39.6548L24.6161 43.3842C24.4149 43.4364 24.1987 43.4588 23.9899 43.4513H23.9862Z"
					fill="#12D231"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M68.7566 43.4512C68.6448 43.4363 68.533 43.4139 68.4249 43.3841L53.2168 39.6547C52.6615 39.5241 52.1806 39.1661 51.8899 38.6776C51.6029 38.1853 51.5171 37.5998 51.6662 37.0478L55.5912 22.5218C55.7403 21.9773 56.0982 21.5149 56.5902 21.2389C57.0785 20.9592 57.66 20.8883 58.1967 21.0375C58.7409 21.1867 59.2031 21.5447 59.479 22.0333C59.7585 22.5255 59.8294 23.1036 59.6803 23.6481L57.0412 33.4191L89.8354 15.8909C90.3348 15.6075 90.9201 15.5366 91.468 15.697C92.0159 15.8536 92.4781 16.2303 92.7465 16.7338C93.0149 17.241 93.0671 17.8302 92.8919 18.3747C92.7204 18.9192 92.3253 19.3705 91.8146 19.6203L59.5796 36.8501L69.4126 39.2929C70.4302 39.5502 71.1049 40.5124 70.9968 41.5566C70.8887 42.6009 70.0314 43.4064 68.984 43.4512C68.9094 43.4549 68.8312 43.4549 68.7529 43.4512H68.7566Z"
					fill="#12D231"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M46.9473 92.9999C45.8402 92.985 44.8525 91.9594 44.8674 90.8555L44.8338 55.5344L37.2447 62.665C36.4321 63.4258 35.0008 63.3773 34.2441 62.5643C33.4875 61.7513 33.5322 60.3192 34.3448 59.5621L45.4973 49.131C46.4217 48.2061 47.6816 48.4448 48.401 49.1646L59.4864 59.7933C60.1127 60.3714 60.3326 61.3485 60.012 62.1354C59.6915 62.9223 58.8528 63.478 58.0029 63.4519C57.4624 63.4407 56.9294 63.2095 56.5529 62.8253L49.0645 55.6276L49.098 90.848C49.1129 91.9743 48.0804 93.0111 46.9547 92.9925L46.9473 92.9999Z"
					fill="#12D231"
				/>
			</g>
			<defs>
				<clipPath id="clip0_5_285">
					<rect width="93" height="93" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export default CenterPoint;
